module.exports = __webpack_public_path__ + "img/bigquery.e58d8250.png";